module.exports = __webpack_public_path__ + "static/img/brand-12.6950c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-12.png
// module id = LNfi
// module chunks = 0